const stack = {
  type: 'frame',
  options: {
    layoutEnabled: true,
    layoutDirection: 'vertical',
    layoutSizeVertical: 'children',
    layoutSizeHorizontal: 'children',
    textContent: 'Stack',
  },
  children: [
    {
      type: 'shape',
      options: { shapeName: 'note', fill: '#FAEBB9' },
    },
    {
      type: 'shape',
      options: { shapeName: 'note', fill: '#FAEBB9' },
    },
    {
      type: 'shape',
      options: { shapeName: 'note', fill: '#FAEBB9' },
    },
    {
      type: 'shape',
      options: { shapeName: 'note', fill: '#FAEBB9' },
    },
    {
      type: 'shape',
      options: { shapeName: 'note', fill: '#FAEBB9' },
    },
  ],
};

const swimlane = {
  type: 'frame',
  options: {
    layoutEnabled: true,
    layoutDirection: 'horizontal',
    layoutSizeVertical: 'children',
    layoutSizeHorizontal: 'children',
    layoutAlignHorizontal: 'center',
    layoutAlignVertical: 'center',
    textContent: 'Swimlane',
  },
  children: [
    {
      type: 'shape',
      options: { shapeName: 'note', fill: '#FAEBB9' },
    },
    {
      type: 'shape',
      options: { shapeName: 'note', fill: '#FAEBB9' },
    },
    {
      type: 'shape',
      options: { shapeName: 'note', fill: '#FAEBB9' },
    },
    {
      type: 'shape',
      options: { shapeName: 'note', fill: '#FAEBB9' },
    },
    {
      type: 'shape',
      options: { shapeName: 'note', fill: '#FAEBB9' },
    },
  ],
};

const board = {
  type: 'frame',
  options: {
    layoutEnabled: true,
    layoutDirection: 'horizontal',
    layoutAlignHorizontal: 'center',
    layoutAlignVertical: 'center',
    layoutGap: 50,
    scaleX: 2.5,
    scaleY: 1.4,
    textContent: 'Board',
  },
  children: [
    {
      type: 'stack',
    },
    {
      type: 'stack',
    },
    {
      type: 'stack',
    },
    {
      type: 'stack',
    },
  ],
};

const components = { stack, swimlane, board };

export type ComponentNames = keyof typeof components;

export default components;
